"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataContext = void 0;
var React = __importStar(require("react"));
var DataContext = React.createContext({});
function useDataContext() {
    return React.useContext(DataContext);
}
exports.useDataContext = useDataContext;
function DataContextProvider(_a) {
    var children = _a.children, editMode = _a.editMode, _b = _a.skeleton, skeleton = _b === void 0 ? false : _b, onEditMode = _a.onEditMode, bulkAction = _a.bulkAction, selectedRowsId = _a.selectedRowsId, onSelectRow = _a.onSelectRow;
    return (React.createElement(DataContext.Provider, { value: {
            editMode: editMode,
            skeleton: skeleton,
            onEditMode: onEditMode,
            bulkAction: bulkAction,
            selectedRowsId: selectedRowsId,
            onSelectRow: onSelectRow,
        } }, children));
}
exports.default = DataContextProvider;
//# sourceMappingURL=DataContext.js.map